import React, { Component } from 'react';
import Loading from './Loading';
import Pagination from './Pagination';
import { _Alert, variable, _post, _getToken, _isLogin } from './Function';
import '../css/Deposit.css';

class DepositTransaction extends Component {
    constructor(props) {
        super(props);
        this.state={
            id: this.props.match.params.id,
            loadingShow: true,
            data: [],
            is_trans: false,
            transaction: [],
            currentPage: 1,
            rowPerPage: 13
        }
        _isLogin().then( value => { 
            if ( value ) this.getDepositTransaction();
        });
    }

    fallBack = (page) => {
        this.setState({ currentPage: page });
    }

    getDepositTransaction() {
        let param = { token: _getToken(), platform: variable().platform, account_id: this.state.id };
        _post('get.deposit.transaction.php', param)
        .then(res => { 
            //console.log('res', res)
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                this.setState({ data: res.data.data, transaction: res.data.transaction, is_trans: true })
            } else {
                this.setState({ data: res.data.data, is_trans: false })
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
            }

        }).catch(err => { 
            this.setState({ loadingShow: false });
          _Alert('error'); 
        });
    }

    renderTransaction() {
        const { rowPerPage, currentPage, transaction } = this.state;
        const indexOfLastTodo = currentPage * rowPerPage;
        const indexOfFirstTodo = indexOfLastTodo - rowPerPage;
        const currentTodos = transaction.slice(indexOfFirstTodo, indexOfLastTodo);

        return(
            <div>
                <table className="table table-deposit">
                    <thead>
                        {
                            ( this.state.transaction.length > 0 ) ?
                                <tr>
                                    <th scope="col" width="27%">วันที่ทำรายการ</th>
                                    <th scope="col" width="28%">รายการ</th>
                                    <th scope="col" width="20%" className="th-title">จำนวนเงิน</th>
                                    <th scope="col" width="25%" className="th-title">ยอดเงินคงเหลือ</th>
                                </tr>
                            :
                                null
                        }
                    </thead>
                    <tbody>   
                        {
                            currentTodos.map((transaction, index) => (
                                <tr key={index}>
                                    <td>{transaction.transaction_time}</td>
                                    <td>{transaction.money_type_name_th}</td>
                                    <td className="th-body"><span className={(transaction.is_status === '+') ? 'is-deposit row-trans' : 'is-withdrawal row-trans'}>
                                        {(transaction.is_status === '+') ? '+ ' + transaction.transaction_deposit : '- ' + transaction.transaction_withdrawal }
                                    </span></td>
                                    <td className="th-body"><span className="row-balance">
                                        {transaction.transaction_balance}
                                    </span></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

                <div className="mobile-content">
                    {
                        currentTodos.map((transaction, index) => (
                            <div key={index} className={(index === 0) ? 'deposit-loop is-first' : 'deposit-loop'}>
                                <div className="deposit-row">
                                    <div className="deposit-row-first"><span className="text-title">วันที่ทำรายการ : </span><span className="text-desc">{transaction.transaction_time}</span></div>
                                    <div className="deposit-row-second"><span className="text-title">รายการ : </span><span className="text-desc">{transaction.money_type_name_th}</span></div>
                                </div>
                                <div className="deposit-row">
                                    <div className="deposit-row-third">
                                        <span className="text-title">จำนวนเงิน : </span>
                                        <span className="text-desc type-desc" className={(transaction.is_status === '+') ? 'is-deposit row-trans mobile-trans' : 'is-withdrawal row-trans mobile-trans'}>
                                            {(transaction.is_status === '+') ? '+ ' + transaction.transaction_deposit : '- ' + transaction.transaction_withdrawal }
                                        </span>
                                    </div>
                                    <div className="deposit-row-fourt">
                                        <span className="text-title">ยอดเงินคงเหลือ : </span>
                                        <span className="text-desc">
                                            {transaction.transaction_balance} บาท
                                        </span>
                                    </div>
                                </div>
                            </div> 
                        ))
                    }
                </div>

                { (this.state.transaction.length > this.state.rowPerPage) ? <Pagination onSelectPage={this.fallBack} rowPerPage={this.state.rowPerPage} lengths={this.state.transaction.length} /> : null }
            </div>
        )
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                        <div className="card-title-text">เงินฝาก</div>
                    </div>
                    <div className="card-content card-trans-content">
                        <div className="card-row">
                        <div className="acc-no"><span className="text-title">เลขที่บัญชี : </span><span className="text-desc">{this.state.data.account_id}</span></div>
                        <div className="acc-name"><span className="text-title">ชื่อบัญชี : </span><span className="text-desc">{this.state.data.account_name}</span></div>
                    </div>
                    <div className="card-row">
                        <div className="acc-type"><span className="text-title">ประเภทบัญชี : </span><span className="text-desc type-desc">{this.state.data.account_type}</span></div>
                        <div className="acc-total"><span className="text-title">ยอดเงินคงเหลือ : </span><span className="text-desc">{this.state.data.balance} บาท</span></div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-exchange-alt"></i></div>
                        <div className="card-title-text">รายการเคลื่อนไหว (ย้อนหลัง 1 ปี)</div>
                    </div>
                    <div className="card-content card-deposit">
                        { (this.state.is_trans) ?  this.renderTransaction() : <div className="no-data">ไม่พบรายการเคลื่อนไหว</div> }
                    </div>
                </div>
            </div>
        )
    }
}

export default DepositTransaction;